"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * This wrapper enables easier transition if the current
 * lib has breaking changes. Also we can easier migrate
 * to another translation lib.
 */
var backend_1 = __importDefault(require("../plugins/backend"));
var i18next_1 = __importDefault(require("i18next"));
var react_i18next_1 = require("react-i18next");
var env_helpers_1 = require("../../../helpers/env.helpers");
var initI18n = i18next_1.default.use(react_i18next_1.initReactI18next);
var pollingTranslationsInterval = null;
/**
 * Clear translations polling interval.
 *
 */
var stopPolling = function () {
    if (pollingTranslationsInterval) {
        window.clearInterval(pollingTranslationsInterval);
        pollingTranslationsInterval = null;
    }
};
var getPollingTranslationsHandle = function () {
    return pollingTranslationsInterval;
};
/**
 * Reload resources from backend and change language.
 *
 * Reload resources.
 *  - https://www.i18next.com/overview/api#reloadresources
 * Change language:
 *  - https://www.i18next.com/overview/api#changelanguage
 */
var reload = function (locale, catalog) {
    return initI18n.reloadResources(locale, catalog).then(function () {
        return initI18n.changeLanguage(locale);
    });
};
/**
 * Wrapper around i18next instance.
 *
 * https://react.i18next.com/latest/i18next-instance
 */
// prettier-ignore
var init = function (locale, catalog, backend, react, resources) {
    if (!resources) {
        initI18n.use(new backend_1.default());
        var POLLING_INTERVAL_MS = +process.env.REACT_APP_translationsPollingInterval;
        stopPolling();
        if (POLLING_INTERVAL_MS) {
            pollingTranslationsInterval = window.setInterval(function () {
                var lang = locale;
                if (initI18n.isInitialized) {
                    lang = initI18n.language;
                }
                reload(lang, catalog);
            }, POLLING_INTERVAL_MS);
        }
    }
    if (!react) {
        react = {};
    }
    // This will fix react bug when using suspense and hooks
    react.useSuspense = false;
    var envDebug = env_helpers_1.toBool(process.env.REACT_APP_i18next_debug);
    var envSaveMissing = env_helpers_1.toBool(process.env.REACT_APP_i18next_saveMissing);
    return initI18n.init({
        // languages, namespaces, resources
        debug: envDebug,
        lng: locale,
        fallbackLng: {
            // map obsolete iso name `zh-CN` to Chinese Simplified iso name
            // See: https://www.iana.org/assignments/lang-tag-apps/zh-Hans-CN
            'zh-CN': ['zh-Hans'],
            'default': ['en']
        },
        defaultNS: catalog,
        ns: catalog,
        resources: resources,
        // missing keys
        saveMissing: envSaveMissing,
        keySeparator: false,
        nsSeparator: false,
        backend: backend,
        react: react,
    });
};
/**
 * Get language direction from locale.
 *
 * https://www.i18next.com/overview/api#dir
 */
var dir = function (locale) {
    return initI18n.dir(locale);
};
/**
 * It gets the t function and i18n instance
 * inside your functional component.
 *
 * https://react.i18next.com/latest/usetranslation-hook
 */
var translate = function (key, interpolation) {
    return initI18n.t(key, interpolation);
};
/**
 * Get current loaded resource bundle
 *
 * https://www.i18next.com/overview/api#getresourcebundle
 */
var getCurrentResources = function (lang, catalog) {
    var _a, _b;
    return _a = {},
        _a[lang] = (_b = {},
            _b[catalog] = initI18n.getResourceBundle(lang, catalog),
            _b),
        _a;
};
var setNewResources = function (lang, namespace, resources) {
    initI18n.addResourceBundle(lang, namespace, resources, true, true);
    return initI18n.changeLanguage(lang);
};
exports.default = {
    getPollingTranslationsHandle: getPollingTranslationsHandle,
    stopPolling: stopPolling,
    init: init,
    reload: reload,
    dir: dir,
    translate: translate,
    getCurrentResources: getCurrentResources,
    setNewResources: setNewResources,
};
